import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useMapContext } from '../MapContext'
import { Popup as MapLibrePopup } from 'maplibre-gl'
import s from './Popup.less'
import { isPE } from '../../Device'
import PopupPano from './PopupPano'
import {
  POPUP_TYPE_PANO,
  POPUP_TYPE_POI,
  POPUP_TYPE_ADDRESS,
  selectPopupData,
  selectShouldDisplayPopup
} from './popup.selectors'
import PopupPoi from './PopupPoi'
import PopupAddress from './PopupAddress'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { withMapReady } from '../map.utils'
import { useSelector } from 'react-redux'

// webpack:BrowserOnly

const popupDataAreComplete = ({ offset, coords, type }) => type && offset && coords && coords.lat && coords.lng

const getChild = type => {
  switch (type) {
    case POPUP_TYPE_PANO:
      return <PopupPano />
    case POPUP_TYPE_POI:
      return <PopupPoi />
    case POPUP_TYPE_ADDRESS:
      return <PopupAddress />
    default:
      return null
  }
}

const POPUP_ID = 'mapPopupWrapper'

const useMapLibrePopup = () => {
  const popupData = useSelector(selectPopupData)
  const shouldHavePopup = popupDataAreComplete(popupData)
  const [hasPopup, setHasPopup] = useState(0)
  const { type, coords, offset, anchor, maxWidth, withIllustration } = popupData
  const { map } = useMapContext()

  useEffect(() => {
    if (!shouldHavePopup) return

    const popupTypeClass = ` popup-${type}`
    const withIllustrationClass = withIllustration ? ' with-illustration' : ''

    const mapLibrePopup = new MapLibrePopup({
      offset,
      closeButton: false,
      className: `${s.popup}${popupTypeClass}${withIllustrationClass}`,
      anchor,
      maxWidth
    })

    mapLibrePopup.setLngLat(coords).setHTML(`<div id="${POPUP_ID}"></div>`).addTo(map)

    setHasPopup(Date.now())

    return () => {
      mapLibrePopup.remove()
      setHasPopup(0)
    }
  }, [shouldHavePopup])

  return hasPopup && POPUP_ID
}

const PortalPopup = ({ children }) => {
  const popupId = useMapLibrePopup()

  if (!popupId) return null

  const domNode = document.querySelector(`#${popupId}`)
  if (!domNode) return null
  return ReactDOM.createPortal(children, domNode)
}

const Popup = () => {
  const { type } = useSelector(selectPopupData)
  const child = getChild(type)
  const shouldDisplayPopup = useSelector(selectShouldDisplayPopup)

  if (!shouldDisplayPopup || !child) return null
  if (isPE() && type === POPUP_TYPE_ADDRESS) return null

  return isPE() ? <div className={s.popupPE}>{child}</div> : <PortalPopup>{child}</PortalPopup>
}

export default withEmptyFallbackErrorBoundary(withMapReady(Popup))
